<template>
	<a-popover placement="topLeft">
		<template slot="content" >
			<div style="padding: 8px">{{title}}</div>
		</template>
		<div class="record">{{title}}</div>
	</a-popover>
</template>

<script>
export default {
  name: 'popover-tip',
  props: {
    placement: {
      type: String,
      default: 'topLeft'
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang='less'>
	.record {
		width: 120px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
</style>